import { useQuery } from "@tanstack/react-query";

import { interventionKeys } from "../../../redux/services/interventionKeys";
import { getInterventionLevelWiseQuestion } from "./InterventionApi";

export const useGetInterventionLevelWiseQuestion = (payload) => {
  const {
   
    domainCategoryId,
    domainMasterId,
    classroomObservationId,
    inputLevelId,
    gradeId , 
    languageId
  } = payload || {};

  return useQuery({
    queryKey: interventionKeys.levelWiseQuestion({
      gradeId, 
      languageId,
      domainCategoryId,
      domainMasterId,
      classroomObservationId,
      inputLevelId,
    }),
    queryFn: () =>
      getInterventionLevelWiseQuestion({
      gradeId , 
      languageId,
        domainCategoryId,
        domainMasterId,
        classroomObservationId,
        inputLevelId,
      }),
    enabled: Boolean(
      gradeId &&
        languageId &&
        domainCategoryId &&
        domainMasterId &&
        classroomObservationId &&
        inputLevelId
    ),
  });
};
